import React from 'react';
import { Container, Typography, Box } from '@mui/material';
import BackButtonDesktop from '../../components/BackButtonDesktop';

export default function TermsAndConditions() {
  return (
    <Container maxWidth="md" sx={{ py: 4 }}>
      <Typography variant="h4" gutterBottom>
        Termini e Condizioni di www.deskstudio.it
      </Typography>
      <Typography variant="subtitle2" gutterBottom>
        Ultimo aggiornamento: 6 Febbraio 2026
      </Typography>

      <Box sx={{ mt: 3 }}>
        <Typography variant="h6">1. Accettazione dei termini</Typography>
        <Typography paragraph>
          Utilizzando questo sito, l’utente accetta di rispettare questi termini e condizioni. Se non li accetta, è invitato a non utilizzare il sito.
        </Typography>

        <Typography variant="h6">2. Servizi offerti</Typography>
        <Typography paragraph>
          Il sito fornisce servizi di gestione online delle scadenze fiscali. Tutti i servizi sono descritti nelle rispettive pagine del sito e nelle manuale utente scaricabile.
        </Typography>

        <Typography variant="h6">3. Registrazione e account</Typography>
        <Typography paragraph>
          I servizi offerti richiedono la registrazione. L’utente è responsabile delle informazioni inserite e della riservatezza dei propri dati di accesso.
        </Typography>

        <Typography variant="h6">4. Pagamenti</Typography>
        <Typography paragraph>
          Tutti i pagamenti online sono gestiti tramite Stripe, secondo le loro policy di sicurezza. Alternativamente è possibile effettuare un bonifico ed allegare la ricevuta di pagamento. Eventuali rimborsi o contestazioni seguono le regole indicate durante la transazione.
        </Typography>

        <Typography variant="h6">5. Responsabilità</Typography>
        <Typography paragraph>
          Il sito e i suoi gestori non sono responsabili per danni diretti o indiretti derivanti dall’utilizzo del sito, salvo obblighi di legge.
        </Typography>

        <Typography variant="h6">6. Proprietà intellettuale</Typography>
        <Typography paragraph>
          Tutti i contenuti, loghi, marchi e materiali pubblicati sono di proprietà del sito o dei rispettivi titolari e non possono essere copiati o utilizzati senza autorizzazione.
        </Typography>

        <Typography variant="h6">7. Modifiche ai termini</Typography>
        <Typography paragraph>
          Ci riserviamo il diritto di aggiornare questi termini in qualsiasi momento. Le modifiche saranno pubblicate online con indicazione della data di aggiornamento.
        </Typography>

        <Typography variant="h6">8. Legge applicabile e controversie</Typography>
        <Typography paragraph>
          Questi termini sono regolati dalla legge italiana. Eventuali controversie saranno risolte dai tribunali competenti in Italia.
        </Typography>
      </Box>
      <BackButtonDesktop />
    </Container>
  );
}